import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiResponse, IRequiredWorkOrder } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getRequiredWorkOrdersUUID = createUUID();

export const useRequiredWorkOrders = () => {
  const stateManager = useComponentState();

  const [requiredWorkOrders, setRequiredWorkOrders] = useState<
    IRequiredWorkOrder[]
  >([]);

  const getRequiredWorkOrders = async (
    id: string
  ): Promise<IApiResponse<IRequiredWorkOrder[]>> => {
    stateManager.abort(getRequiredWorkOrdersUUID);
    return stateManager.run(async () => {
      const response = await taskService.workOrders.getRequiredWorkOrders({
        id,
      });

      if (response.status === HTTP_STATUSES.OK) {
        setRequiredWorkOrders(response.data);
      }

      return response;
    }, getRequiredWorkOrdersUUID);
  };

  return {
    requiredWorkOrders,
    isLoading: stateManager.isBusy(),
    setRequiredWorkOrders,
    getRequiredWorkOrders,
  };
};
